module Core {
    angular.module('core').filter('articlePrice', [() => {
        return (prix: number, qte: number = 0, qteLivree: number = null): number => {
            prix *= qteLivree == undefined ? qte : qteLivree;
            return prix;
        };
    }]);
}